<div class="content">
  <img src="../../../images/AMA Traffic Cones.svg" />
  <h1>The site is currently under maintenance.</h1>
  <h3>We are doing some work on the site and it will be back shortly.</h3>
</div>
